import { KEYCHRON_CS2TIMED_brandVariables } from "./brands/KEYCHRON_CS2TIMED_brandvariables";
import { TCL_CS2TIMED_brandVariables } from "./brands/TCL_CS2TIMED_brandvariables";
import { JBL_CSTIMED_brandVariables } from "./brands/JBL_CS2TIMED_brandvariables";
import { ELGIGANTEN_brandVariables } from "./brands/ELGIGANTEN_brandvariables";
import { LOGITECH_brandVariables } from "./brands/LOGITECH_brandvariables";
import { FORTNITE_brandVariables } from "./brands/FORTNITE_brandvariables";
import { FALLGUYS_brandVariables } from "./brands/FALLGUYS_brandvariables";
import { LEGO_F1_brandVariables } from "./brands/LEGO_F1_brandvariables";

const brandInfo = {
  "localhost:5173": TCL_CS2TIMED_brandVariables, // Local dev
  "localhost:5174": JBL_CSTIMED_brandVariables, // Local dev
  "iplay-leaderboard-v2.web.app": TCL_CS2TIMED_brandVariables, // Test deployment
  "iplay-leaderboard-v2.firebaseapp.com": ELGIGANTEN_brandVariables, //Racing leaderboard
  "lego-ldbrd.iplay.dk": LEGO_F1_brandVariables,
  "logitechg-ldbrd.iplay.dk": LOGITECH_brandVariables,
  "keychron-ldbrd.iplay.dk": KEYCHRON_CS2TIMED_brandVariables, // CS TIMED MAP

  // Old domains, dont work anymore (was on WOG project), used as reference
  "elgiganten-ldbrd.iplay.dk": ELGIGANTEN_brandVariables, // Racing leaderboard
  "fortnite-ldbrd.iplay.dk": FORTNITE_brandVariables, // Fortnite leaderboard
  "fallguys-ldbrd.iplay.dk": FALLGUYS_brandVariables, // Fallguys leaderboard
  "logitech-ldbrd.iplay.dk": LOGITECH_brandVariables, // Racing leaderboard
  "jbl-ldbrd.iplay.dk": JBL_CSTIMED_brandVariables, // CS TIMED MAP
  "tcl-ldbrd.iplay.dk": TCL_CS2TIMED_brandVariables, // CS TIMED MAP
};

export const brand = brandInfo[window.location.host];
